import { useQuery } from '@apollo/client';
import { createError } from '@common/neo.tax';

import { GetPayrollExpenseQuery, GetPayrollExpenseQueryVariables, GET_PAYROLL_EXPENSE } from '@neo.tax/shared';

export type PayrollExpense = GetPayrollExpenseQuery['getPayrollExpense'];

export const usePayrollExpense = (
  payrollExpenseId: string | null | undefined,
  options?: {
    skip?: boolean;
  },
):
  | {
      payrollExpense: null;
      loading: boolean;
    }
  | {
      payrollExpense: PayrollExpense;
      loading: false;
    } => {
  const { skip } = options || {};
  const shouldSkip = skip || !payrollExpenseId;
  const { data, error, loading } = useQuery<GetPayrollExpenseQuery, GetPayrollExpenseQueryVariables>(
    GET_PAYROLL_EXPENSE,
    shouldSkip ? { skip: true } : { variables: { payrollExpenseId } },
  );

  if (loading) {
    return { payrollExpense: null, loading: true };
  }
  if (error) {
    throw error;
  }
  if (!data && !shouldSkip) {
    throw createError('MissingPayrollExpense', `Failed to load PayrollExpense with id ${payrollExpenseId}`);
  }

  return {
    payrollExpense: data?.getPayrollExpense || null,
    loading,
  };
};
